import { SurveyAnswer } from "./SurveyAnswer"
import { Microsite } from "./Microsite"
import { SectionQuestion } from "./SectionQuestion"
import { SurveySection } from "./SurveySection"
import { UploadFile } from "antd"

interface SurveyCompletion {
	id: number
	userId: number
	surveyId: number
	completedAt: string
	completed: boolean
	commentary: string | null
	pdf?: string
	user: {
		id: number
		email: string
		language: string
		name: string
		city: string
		birthdate: string
		picture: string
		phoneNumber: string
		bio: string
		website: string
		username: string
		goal: string
		status: string
		createdFrom: string
	}
}

interface ContructorParams {
	id?: number
	title: string
	title_en: string
	title_ca: string
	description?: string
	description_en?: string
	description_ca?: string
	createdAt?: Date
	microsites?: Microsite[]
	answers?: SurveyAnswer[]
	sections?: SurveySection[]
	status?: boolean
	image?: string | UploadFile
	marketplaces?: ("ES" | "MX")[]
	surveyCompletitions?: SurveyCompletion[]
	adminRecommendation?: string
}

export class Survey {
	public readonly id?: number
	public readonly title: string
	public readonly title_en: string
	public readonly title_ca: string
	public readonly description?: string
	public readonly description_en?: string
	public readonly description_ca?: string
	public readonly createdAt?: Date
	public readonly microsites?: Microsite[]
	public readonly answers?: SurveyAnswer[]
	public readonly sections?: SurveySection[]
	public readonly status?: boolean
	public readonly image?: string | UploadFile
	public readonly marketplaces?: ("ES" | "MX")[]
	public readonly surveyCompletitions?: SurveyCompletion[]
	public readonly adminRecommendation?: string

	constructor(params: ContructorParams) {
		this.id = params.id
		this.title = params.title
		this.title_en = params.title_en
		this.title_ca = params.title_ca
		this.description = params.description
		this.description_en = params.description_en
		this.description_ca = params.description_ca
		this.createdAt = params.createdAt ? new Date(params.createdAt) : undefined
		this.microsites = params.microsites
		this.answers = params.answers
		this.sections = params.sections
		this.status = params.status
		this.image = params.image
		this.marketplaces = params.marketplaces
		this.adminRecommendation = params.adminRecommendation
		this.surveyCompletitions = params.surveyCompletitions
	}
}

export type { SurveyCompletion }
